import React from "react";

type PropsType = {
  color?: string;
  style?: React.CSSProperties;
  size?: number;
};

const ArrowRight = ({
  size = 24,
  style = {},
  color = "currentColor",
}: PropsType) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M13.293 18.6947C13.1055 18.5072 13.0002 18.2529 13.0002 17.9877C13.0002 17.7225 13.1055 17.4682 13.293 17.2807L17.586 12.9877H4C3.73478 12.9877 3.48043 12.8824 3.29289 12.6948C3.10536 12.5073 3 12.2529 3 11.9877C3 11.7225 3.10536 11.4681 3.29289 11.2806C3.48043 11.0931 3.73478 10.9877 4 10.9877H17.586L13.293 6.69471C13.1108 6.50611 13.01 6.25351 13.0123 5.99131C13.0146 5.72911 13.1198 5.4783 13.3052 5.29289C13.4906 5.10749 13.7414 5.00232 14.0036 5.00004C14.2658 4.99776 14.5184 5.09855 14.707 5.28071L20.707 11.2807C20.7752 11.349 20.8331 11.4268 20.879 11.5117L20.889 11.5307V11.5357L20.896 11.5497L20.902 11.5617V11.5697L20.91 11.5877C20.9661 11.7169 20.9943 11.8564 20.9927 11.9972C20.9912 12.138 20.9599 12.2768 20.901 12.4047L20.9 12.4277V12.4367L20.895 12.4477L20.888 12.4607V12.4687L20.88 12.4837V12.4887L20.87 12.5047L20.859 12.5217L20.847 12.5397L20.835 12.5567L20.8 12.5877L20.789 12.6017V12.6077L20.779 12.6197L20.77 12.6307L20.764 12.6377L20.749 12.6547L20.709 12.6967L14.709 18.6967C14.5215 18.8842 14.2672 18.9895 14.002 18.9895C13.7368 18.9895 13.4825 18.8842 13.295 18.6967L13.293 18.6947Z"
        fill={color}
      />
    </svg>
  );
};

export default ArrowRight;
